<template>
    <div id="bookDetails">
        <div class="row mb-5">
            <div class="bkDetails align-self-end col-lg-8 col-md-7  col-sm-7 col-12">
                <h3 class="m-0" style="font-weight:700" v-html="$options.filters.decoder(item.title)"></h3>
                <b v-html="$options.filters.decoder(item.author)"></b>
                <p class="mt-3 mb-4" style="font-size: 13px;" v-html="$options.filters.decoder(item.text)">
                </p>
                <table class="mb-5">
                    <tbody>
                        <tr v-for="(val, key) in item.details" :key="key" v-if="val.length>0"> <td class="pr-4">{{ key }}: </td>    <td>{{ val }}</td></tr>
                    </tbody>
                </table>
                
                <div class="row pl-3" style="display: block;padding: 0px;" v-if="$options.filters.decoder(item.url.url_shop)">
                    <a :href="$options.filters.decoder(item.url.url_shop)" target="_blank" class="btn btn1 mr-3 mb-3 bold">Bestel</a>
                </div>
                <div class="row pl-3" style="display: block;padding: 0px;" v-else>
                    <!-- <a v-if="item.url.url_ako" :href="$options.filters.decoder(item.url.url_ako)" target="_blank" class="btn btn1 mr-3 mb-3 bold">Bestel bij ako.nl</a> -->
                    <a class="btn btn1 mr-3 mb-3 bold" :href="item.url.bolcom"  target="_blank" v-if="item.price_ebook">Bestel bij bol.com als {{ item.details.Bindwijze }}   <!-- <span v-html="item.price"></span> --> </a>
                    <a class="btn btn1 mr-3 mb-3 bold" :href="item.url.bolcom"  target="_blank" v-else>Bestel bij bol.com </a>
                    <a class="btn btn2 bold" :href="item.url.ebook" target="_blank" v-if="item.price_ebook">Bestel bij bol.com als ebook  <!-- <span v-html="item.price_ebook"></span> --> </a>
                    <!-- <a :href="$options.filters.decoder(item.url.url_bookspot)" target="_blank" class="btn btn1 mr-3 mb-3 bold">Bestel bij bookspot.nl</a> -->
                    <a :href="$options.filters.decoder(item.url.url_bruna)" target="_blank" class="btn btn1 mr-3 mb-3 bold">Bestel bij bruna.nl</a>
                    <a :href="$options.filters.decoder(item.url.url_libris)" target="_blank" class="btn btn1 mr-3 mb-3 bold">Bestel bij libris.nl</a><br>
                    <!-- <a v-if="item.url.url_readshop" :href="$options.filters.decoder(item.url.url_readshop)" target="_blank" class="btn btn1 mr-3 mb-3 bold">Bestel bij readshop.nl</a> -->
                    <br>Of koop het boek bij de plaatselijke boekhandel
                </div>
            </div>

            <div class="row bkImage align-self-start col-lg-4 col-md-5 col-sm-5 col-12">
                <div class="col align-self-start m-0 p-0">
                    <img style="margin:0 auto;display:block" :src="item.image.src" :alt="item.image.alt" :title="item.image.title">
                    <a class="btn btn-dark mt-2" :href="item.url.inkijk" target="_blank" v-if="item.url.inkijk">Inkijkexemplaar</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name:'bookDetails',
        props:{
            item:{type:Object,required:true}
        },
        filters:{
            decoder : function(value){
                if (!value) return ''
                return window.atob(value);
            }
        }
        
    }
</script>

<style scoped>
    #bookDetails{

    }
    .bkDetails .btn1{
        color: white;
        background: gray;
        border-radius: 0px;
        padding: 0px 8px;
        padding-bottom:4px;
    }
     .bkDetails .btn2{
            color: white;
            background: gray;
            border-radius: 0px;
            padding: 0px 8px;
            padding-bottom:4px;
    }
    .bkDetails .btn1 span,.bkDetails .btn2 span{
        display: block;
        line-height: 18px;
        text-align: right;
    }

    .bkImage{
        padding: 0px 0px 0px 14px;
    }
    .bkImage img{
        width: 100%;
    }
    .bkImage .btn{
        border-radius: 0px;
        background:black !important;
        margin:0 auto; 
        padding:5px 25px;
        display: block;
    }

    .bold{
        font-weight: 700;
    }

    table{
        font-size: 12px;
    }

    @media (max-width:576px){
         .bkImage img{
            margin: 0 auto;
            display: block;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/book-details.vue